import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ModernAdminDashboard from './ModernAdminDashboard';
import AdminProducts from './AdminProducts';
import AdminCategories from './AdminCategories';
import AdminOrders from './AdminOrders';
import AdminUsers from './AdminUsers';
import AdminSuppliers from './AdminSuppliers';
import AdminDelivery from './AdminDelivery';
import AdminReports from './AdminReports';
import AdminSettings from './AdminSettings';
import AdminPromotions from './AdminPromotions';
import AdminBanners from './AdminBanners';
import AdminTest from './AdminTest';

const AdminRouter = () => {
  return (
    <Routes>
      <Route path="" element={<ModernAdminDashboard />} />
      <Route path="test" element={<AdminTest />} />
      <Route path="products" element={<AdminProducts />} />
      <Route path="products/add" element={<AdminProducts />} />
      <Route path="products/edit/:id" element={<AdminProducts mode="edit" />} />
      <Route path="categories" element={<AdminCategories />} />
      <Route path="orders" element={<AdminOrders />} />
      <Route path="orders/pending" element={<AdminOrders filter="pending" />} />
      <Route path="orders/confirmed" element={<AdminOrders filter="confirmed" />} />
      <Route path="orders/processing" element={<AdminOrders filter="processing" />} />
      <Route path="orders/shipped" element={<AdminOrders filter="shipped" />} />
      <Route path="orders/delivered" element={<AdminOrders filter="delivered" />} />
      <Route path="orders/completed" element={<AdminOrders filter="delivered" />} />
      <Route path="orders/cancelled" element={<AdminOrders filter="cancelled" />} />
      <Route path="users" element={<AdminUsers />} />
      <Route path="users/farmers" element={<AdminUsers type="farmers" />} />
      <Route path="users/buyers" element={<AdminUsers type="buyers" />} />
      <Route path="users/suppliers" element={<AdminUsers type="suppliers" />} />
      <Route path="suppliers" element={<AdminSuppliers />} />
      <Route path="delivery" element={<AdminDelivery />} />
      <Route path="reports" element={<AdminReports />} />
      <Route path="settings" element={<AdminSettings />} />
      <Route path="promotions" element={<AdminPromotions />} />
      <Route path="banners" element={<AdminBanners />} />
    </Routes>
  );
};

export default AdminRouter;
